import { render, staticRenderFns } from "./EventosAprobacion.vue?vue&type=template&id=14e9537d&scoped=true&"
import script from "./EventosAprobacion.vue?vue&type=script&lang=js&"
export * from "./EventosAprobacion.vue?vue&type=script&lang=js&"
import style0 from "./EventosAprobacion.vue?vue&type=style&index=0&id=14e9537d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e9537d",
  null
  
)

export default component.exports